import axios from 'axios';
import Translator from 'bazinga-translator';
import { init as clients } from './../clients/index';
import { init as clientUpload } from './../clients-upload/clients-upload';
import { init as logotypeUpload } from './../logotype-upload/logotype-upload';
import { init as activityFeed } from './../activity-feed/index';

export function setTranslations() {
    const translationPath = Routing.generate('bazinga_jstranslation_js', {'domain': 'app', '_format': 'json', 'locales': 'en,pl'});

    axios.get(translationPath).then((response) =>{
        Translator.fromJSON(response.data);
    }).then(() =>{
        clients();
        clientUpload();
        logotypeUpload();
        activityFeed();
    });
    
}


// WEBPACK FOOTER //
// ./src/_app/layout/translations.js